/**************************************************
 * Nombre:       Etiquetas_Autor
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Chip, Grid, Typography} from "@mui/material";
import {CalendarMonth, PersonOutline} from "@mui/icons-material";
import {theme} from "../../../../Tema";
import 'dayjs/locale/es'
import dayjs from "dayjs"; // load on demand

dayjs.locale('es')

const Etiquetas_Autor = ({item}) => {

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'center'}
            size={{xs: 12, sm: 12, md: 12}}
            spacing={1}
        >




            {item.categorias && item.categorias.map((it) =>{
                return (
                    <Chip label={it} color="primary" size="small"/>
                )
            })}


            <Typography sx={{fontSize: 14, mt: -1, color: '#00000080'}}>
                    <span>
                       <PersonOutline sx={{fill: theme.palette.primary.main, mt: 0.8, mb: -0.8, mr: 0.5}}/>
                    </span>
                <span style={{fontWeight: 'bold', marginRight: 5, color: theme.palette.primary.main}}>
                        By
                    </span>

                {item.autor}
            </Typography>


            <Typography sx={{fontSize: 14, mt: -1, color: '#00000080'}}>
                    <span>
                       <CalendarMonth sx={{fill: theme.palette.primary.main, mt: 0.8, mb: -0.8, mr: 0.5}}/>
                    </span>

                {dayjs(item.fechaPublicacion).format('MMMM DD, YYYY') }
            </Typography>

        </Grid>
    )

}
export default Etiquetas_Autor